export default __webpack_public_path__ + "static/media/tablemoreDeatilsIcon.dfbb6736.svg";